import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { filter, map } from 'rxjs/operators';
import { Action } from 'redux';
import { ListMultipleTracks } from '../action-creators';
import { ListReleasesSuccess } from '../../release/action-creators';
import { LIST_RELEASES_SUCCESS } from '../../release/actions';


export const listMultipleTracksAfterReleasesEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, ListReleasesSuccess>(LIST_RELEASES_SUCCESS),
    filter((action) => !!action.includeTracks),
    map((action) => new ListMultipleTracks(action.releases.map((r) => r.id)))
  );